import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "col-12 col-md-12 p-0" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "member-id" }, [
  /*#__PURE__*/_createTextVNode(" Member ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "group-name" }, " Group Name ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Group ID ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-insured" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: 2 }, "18-Self", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "insured-first-name" }, " Insured First Name ", -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "insured-middle-name" }, " Insured middle Name ", -1 /* HOISTED */)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "insured-last-name" }, " Insured last Name ", -1 /* HOISTED */)
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "insured-date-of-birth" }, " Date of Birth ", -1 /* HOISTED */)
const _hoisted_23 = { class: "input-group date datepickerInput" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  id: "insured_Gender_Label",
  for: "insured-gender"
}, " Gender ", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Gender", -1 /* HOISTED */)
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "address-line-one" }, "Address Line 1 ", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "address-line-two" }, "Address Line 2 ", -1 /* HOISTED */)
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "address-city" }, "Address City ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "address-state" }, "State ", -1 /* HOISTED */)
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "address-zip" }, "Zip ", -1 /* HOISTED */)
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "address-zip4" }, "Zip-4 ", -1 /* HOISTED */)
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "employer-name" }, " Employer Name ", -1 /* HOISTED */)
const _hoisted_43 = { class: "col-12 col-md-12 p-0" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "deductible-amount" }, " Deductible Amount ", -1 /* HOISTED */)
const _hoisted_46 = { class: "form-group d-flex flex-row justify-content-between" }
const _hoisted_47 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_48 = ["id", "name"]
const _hoisted_49 = ["for"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Deductible Met", -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Copay Amount ", -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral[_ctx.insurer?.memberID].$error ? '' : 'field-invalid'}`]),
          maxlength: "50",
          name: "member-id",
          type: "text",
          placeholder: "Enter Member ID",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Referral[_ctx.insurer?.memberID]) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral[_ctx.insurer?.memberID].$touch && _ctx.v$.referral.Referral[_ctx.insurer?.memberID].$touch(...args)))
        }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
          [_vModelText, _ctx.referral.Referral[_ctx.insurer?.memberID]]
        ]),
        (_ctx.v$.referral.Referral[_ctx.insurer?.memberID].$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Member ID is required."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-name",
          type: "text",
          placeholder: "Enter Group Name",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.Referral[_ctx.insurer?.groupName]) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.referral.Referral[_ctx.insurer?.groupName]]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Group ID",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Referral[_ctx.insurer?.groupID]) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.referral.Referral[_ctx.insurer?.groupID]]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          name: "relationship-to-insured",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.relationshipInsuredTo) = $event))
        }, [
          _hoisted_12,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.relationshipToInsuredEnum), ([key, value]) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: value.value
            }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_13))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, _ctx.relationshipInsuredTo]
        ])
      ]),
      (_ctx.referral && _ctx.referralOptions && _ctx.relationshipInsuredTo !== null && _ctx.relationshipInsuredTo !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "insured-first-name",
                type: "text",
                placeholder: "Enter Insured First Name",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].FirstName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].FirstName]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "insured-middle-name",
                type: "text",
                placeholder: "Enter Insured Middle Name",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].MiddleInitial) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].MiddleInitial]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "insured-last-name",
                type: "text",
                placeholder: "Enter Insured last Name",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].LastName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].LastName]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "insured-date-of-birth",
                      class: "form-control",
                      placeholder: "MM/DD/YYYY",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].InsuredDateOfBirth) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].InsuredDateOfBirth]
                    ]),
                    _hoisted_24
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["getDate"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                id: "Insured_Gender",
                class: "form-select",
                name: "insured-gender",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].InsuredGender) = $event))
              }, [
                _hoisted_27,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.gender, (gender, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: gender.text
                  }, _toDisplayString(gender.text), 9 /* TEXT, PROPS */, _hoisted_28))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].InsuredGender]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "address-line-one",
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressLine1) = $event)),
                placeholder: "Enter Address"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressLine1]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressLine2) = $event)),
                class: "form-control",
                maxlength: "50",
                name: "address-line-two",
                type: "text",
                placeholder: "Enter Address"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressLine2]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressCity) = $event)),
                class: "form-control",
                maxlength: "50",
                name: "address-city",
                type: "text",
                placeholder: "Enter City"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressCity]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressState) = $event)),
                class: "form-control",
                maxlength: "50",
                name: "address-state",
                type: "text",
                placeholder: "Enter state"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressState]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressStateCode) = $event)),
                class: "form-control",
                maxlength: "5",
                name: "address-zip",
                type: "text",
                placeholder: "Enter zip"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressStateCode]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressZipFFour) = $event)),
                class: "form-control",
                maxlength: "4",
                name: "address-zip4",
                type: "text",
                placeholder: "Enter Zip 4"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer.details].Address.AddressZipFFour]
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "employer-name",
          type: "text",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].EmployerName) = $event)),
          placeholder: "Enter Employer Name"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].EmployerName]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "deductible-amount",
          type: "text",
          placeholder: "Enter Deductible Amount",
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].DeductibleAmount) = $event)),
          "number-only": "decimal"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].DeductibleAmount]
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: _ctx.insurer.details,
            name: _ctx.insurer.details,
            class: "form-check-input au-target",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].DeductibleMet) = $event))
          }, null, 8 /* PROPS */, _hoisted_48), [
            [_vModelCheckbox, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].DeductibleMet]
          ]),
          _createElementVNode("label", {
            class: "form-check-label flex-grow-0",
            for: _ctx.insurer.details
          }, _hoisted_51, 8 /* PROPS */, _hoisted_49)
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          id: "copay-amount",
          name: "copay-amt",
          type: "text",
          placeholder: "Enter Copay Amount",
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].CopayAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.referral.Referral.AdditionalBillingInfo[_ctx.insurer?.details].CopayAmount]
        ])
      ]),
      _hoisted_54
    ])
  ]))
}